import { Service, signal } from '@angular/core';

import { RegistruCMJ, RegistruCMR } from '../models/cautare.model';

/** Rezultatele ultimei cautari de medici, in registrul CMJ si in registrul CMR. */
@Service()
export class CautareStore {
    private readonly listaCmjState = signal<RegistruCMJ | null>(null);
    private readonly listaCmrState = signal<RegistruCMR | null>(null);

    readonly listaCmj = this.listaCmjState.asReadonly();
    readonly listaCmr = this.listaCmrState.asReadonly();

    setListaCmj(lista: RegistruCMJ) {
        this.listaCmjState.set(lista);
    }

    clearListaCmj() {
        this.listaCmjState.set(null);
    }

    setListaCmr(lista: RegistruCMR) {
        this.listaCmrState.set(lista);
    }

    clearListaCmr() {
        this.listaCmrState.set(null);
    }
}
